<script setup lang="ts">
interface HotelSelectionContentDesktopLayoutProps {
  fullScreenMap?: boolean;
}

const props = withDefaults(
  defineProps<HotelSelectionContentDesktopLayoutProps>(),
  {
    fullScreenMap: false,
  }
);
</script>

<template>
  <div class="hotel-selection-content-desktop-layout">
    <div class="left-column">
      <slot name="leftColumn" />
    </div>
    <div v-show="!props.fullScreenMap" class="middle-column">
      <div class="middle-column-top"><slot name="middleColumnTop" /></div>
      <div class="middle-column-bottom">
        <slot name="middleColumnBottom" />
      </div>
    </div>
    <div class="right-column">
      <slot name="rightColumn" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-content-desktop-layout {
  --left-column-width: 300px;
  height: 100%;
  background-color: var(--color-off-white);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  ::-webkit-scrollbar-track {
    background: var(--color-white);
  }
  .left-column,
  .middle-column,
  .right-column {
    height: 100%;
    min-width: 0;
  }

  .left-column {
    border-right: 1px solid var(--color-neutral-30);
    width: var(--left-column-width);
    overflow-y: auto;
  }

  .middle-column {
    background-color: var(--color-off-white);
    flex: 7;
    width: calc(75% - var(--left-column-width));
    ::-webkit-scrollbar-track {
      background: var(--color-off-white);
    }
  }

  .right-column {
    flex: 4;
    box-shadow: var(--shadow-elevation-100);
  }

  .middle-column {
    display: flex;
    flex-direction: column;

    .middle-column-bottom {
      overflow-y: auto;
      width: calc(100% - 1px);
    }
  }

  @include for-less-or-equal-than-1535-px {
    .left-column {
      display: none;
    }

    .middle-column {
      flex: 7;
    }
    .right-column {
      flex: 4;
    }
  }

  @include for-less-or-equal-than-1199-px {
    .middle-column {
      flex: 5;
    }

    .right-column {
      flex: 3;
    }
  }
}
</style>
